function loadFonts({ brand }) {
    // attach font-face defs outside the shadow dom
    const fontStyleElmt = document.createElement('link');
    fontStyleElmt.rel = 'stylesheet';

    if (brand === 'kbb') {
        fontStyleElmt.href = 'https://fonts.googleapis.com/css2?family=Open+Sans:wght@300;400;700;900&display=swap';
    }
    else {
        fontStyleElmt.href = 'https://fonts.googleapis.com/css2?family=Roboto:wght@300;400;700;900&display=swap'
    }

    fontStyleElmt.crossOrigin = 'anonymous';
    document.head.appendChild(fontStyleElmt);

    if (brand === 'kbb') {
        const openSanFontelmt = document.createElement('link');
        openSanFontelmt.rel = 'stylesheet';
        openSanFontelmt.href = 'https://fonts.googleapis.com/css2?family=Montserrat:wght@300;400;700;900&display=swap'
        openSanFontelmt.crossOrigin = 'anonymous'
        document.head.appendChild(openSanFontelmt);
    }
}

export default loadFonts;
